import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227e4b65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { key: 0 }

import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-overview-4',
  setup(__props) {

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            (item.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.name) + "：", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(item.value), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})